import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.some.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('div', {
    staticClass: "container px-3 px-md-0 pt-0"
  }, [_c('div', {
    staticClass: "card mb-4"
  }, [_c('div', {
    ref: "scrollPoint",
    staticClass: "card-body"
  }, [_c('p', {
    staticClass: "card-text"
  }, [_vm._v(" ISBE calculates the program's "), _c('strong', [_vm._v(_vm._s(_vm.routeDomain ? _vm.routeDomain.Name : _vm.overall.Name))]), _vm._v(" score based on " + _vm._s(_vm.routeDomain ? _vm.routeDomain.Indicators.length : _vm.overall.Indicators.length) + " indicators " + _vm._s(_vm.routeDomain ? "" : `organized into 4 domains`) + " over 5 years. The possible designations are: "), _c('span', {
    staticClass: "badge",
    class: `badge-${_vm.DomainDesignation.exemplary.bgColor}`
  }, [_vm._v(_vm._s(_vm.DomainDesignation.exemplary.label))]), _c('span', {
    staticClass: "badge",
    class: `badge-${_vm.DomainDesignation.commendable.bgColor}`
  }, [_vm._v(_vm._s(_vm.DomainDesignation.commendable.label))]), _c('span', {
    staticClass: "badge",
    class: `badge-${_vm.DomainDesignation.developing.bgColor}`
  }, [_vm._v(_vm._s(_vm.DomainDesignation.developing.label))]), _c('span', {
    staticClass: "badge",
    class: `badge-${_vm.DomainDesignation.needsImprovement.bgColor}`
  }, [_vm._v(_vm._s(_vm.DomainDesignation.needsImprovement.label))]), _vm._v(" or "), _c('span', {
    staticClass: "badge",
    class: `badge-${_vm.DomainDesignation.noScore.bgColor}`
  }, [_vm._v(_vm._s(_vm.DomainDesignation.noScore.label))])])]), _c('div', {
    staticClass: "card-footer"
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function ($event) {
        return _vm.showVideoModal($event);
      }
    }
  }, [_c('i', {
    staticClass: "far fa-play-circle"
  }), _vm._v(" Watch a video about the IEPP's goals ")])])])]), _c('div', [_c('transition', {
    attrs: {
      "name": _vm.transitionName
    },
    on: {
      "leave": _vm.leave,
      "enter": _vm.enter,
      "after-enter": _vm.afterEnter,
      "enter-cancelled": _vm.enterCancelled
    }
  }, [_vm.entityProgram && !_vm.routeDomain ? _c('div', {
    key: "overall"
  }, [_c('div', {
    staticClass: "container px-3 px-md-0"
  }, [_c('div', {
    staticClass: "card list-group list-group-flush unbound mb-4 mt-0 p-0"
  }, [_vm._l(_vm.domains, function (domain, index) {
    return _c('div', {
      key: domain.DomainId
    }, [_c('a', {
      staticClass: "list-group-item list-group-item-action",
      class: {
        'mt-2': index === 0
      },
      attrs: {
        "href": "#"
      },
      on: {
        "click": function ($event) {
          return _vm.setDomain($event, domain);
        }
      }
    }, [_c('domain-display', {
      staticClass: "py-2 py-md-0",
      attrs: {
        "domain": domain,
        "clickable": true,
        "facts": _vm.entityProgram.Facts.filter(x => domain.Indicators.some(y => y.DomainIndicatorId === x.DomainIndicatorId))
      }
    })], 1), _vm.domains.length !== index + 1 ? _c('div', {
      staticClass: "divider dashed mx-4 my-2"
    }) : _vm._e()]);
  }), _c('div', {
    staticClass: "divider mt-2"
  }), _c('router-link', {
    staticClass: "list-group-item list-group-item-action rounded-bottom bg-light",
    attrs: {
      "to": {
        name: 'programScoreCard',
        query: {
          scrollTop: true
        },
        params: {
          entityId: _vm.entityProgram.EntityId,
          programId: _vm.entityProgram.ProgramId
        }
      }
    }
  }, [_c('domain-display', {
    staticClass: "py-2 py-md-0",
    attrs: {
      "clickable": true,
      "domain": _vm.overall,
      "facts": _vm.entityProgram.Facts
    }
  })], 1)], 2)])]) : _c('div', {
    key: "domain"
  }, [_c('div', {
    staticClass: "container px-3 px-md-0"
  }, [_c('div', {
    staticClass: "card list-group list-group-flush unbound mb-4 mt-0 p-0"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('a', {
    staticClass: "btn btn-primary",
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.clearDomain
    }
  }, [_c('i', {
    staticClass: "fas fa-chevron-circle-left mr-1"
  }), _vm._v(" Back to Overall ")])]), _c('div', {
    staticClass: "list-group-item rounded-top flex-fill"
  }, [_c('domain-display', {
    staticClass: "py-2 py-md-0 mt-2",
    attrs: {
      "domain": _vm.routeDomain,
      "facts": _vm.entityProgram.Facts.filter(x => _vm.routeDomain.Indicators.some(y => y.DomainIndicatorId === x.DomainIndicatorId))
    }
  })], 1), _vm._l(_vm.routeDomain.Indicators, function (domainIndicator, index) {
    return _c('div', {
      key: domainIndicator.DomainIndicatorId
    }, [_c('div', {
      staticClass: "divider dashed mx-4 mt-1 mb-1",
      class: {
        'd-md-none': index != 0
      }
    }), _c('div', {
      staticClass: "list-group-item",
      class: {
        'rounded-bottom': index + 1 === _vm.routeDomain.Indicators.length
      }
    }, [_c('domain-indicator-display', {
      staticClass: "py-2 py-md-0",
      attrs: {
        "domain": _vm.routeDomain,
        "domain-indicator": domainIndicator,
        "fact": _vm.entityProgram.Facts.find(x => domainIndicator.DomainIndicatorId === x.DomainIndicatorId)
      }
    })], 1)]);
  }), _c('div', {
    staticClass: "card-footer mt-2"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'programScoreCard',
        query: {
          scrollTop: true
        },
        params: {
          entityId: _vm.entityProgram.EntityId,
          programId: _vm.entityProgram.ProgramId
        }
      }
    }
  }, [_vm._v(" See how this data is used to create scores "), _c('i', {
    staticClass: "fas fa-chevron-circle-right ml-1"
  })])], 1)], 2)])])])], 1), _c('div', {
    staticClass: "container px-3 px-md-0 pb-4 pt-0"
  }, [_c('div', {
    staticClass: "row mb-4"
  }, [_c('div', {
    staticClass: "col-lg-6 mb-4 mb-lg-0"
  }, [_c('div', {
    staticClass: "card h-100"
  }, [_vm._m(0), _c('div', {
    staticClass: "card-body"
  }, [_c('p', {
    staticClass: "card-text",
    domProps: {
      "innerHTML": _vm._s(_vm.routeDomain ? _vm.routeDomain.Why : _vm.overallWhy)
    }
  })]), _c('div', {
    staticClass: "card-footer"
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function ($event) {
        return _vm.showVideoModal($event);
      }
    }
  }, [_c('i', {
    staticClass: "far fa-play-circle"
  }), _vm._v(" Watch a video about the IEPP's goals ")])])])]), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('div', {
    staticClass: "card h-100"
  }, [_vm._m(1), _c('div', {
    staticClass: "card-body"
  }, [_c('p', {
    staticClass: "card-text"
  }, [_vm._v(" Programs receive an overall performance designation and a designation for each domain. The performance designations are based on the percentage of points that a program earns. ")]), _c('dl', {
    staticClass: "px-2 mb-0"
  }, _vm._l(_vm.designations, function (designation, index) {
    return _c('div', {
      key: index,
      staticClass: "row"
    }, [_c('dt', {
      staticClass: "col-5 mb-2"
    }, [_c('span', {
      class: `badge badge-${designation.bgColor}`
    }, [_vm._v(_vm._s(designation.label))])]), _c('dd', {
      staticClass: "col-7 mb-2 text-muted"
    }, [_c('span', {
      attrs: {
        "data-toggle": designation.friendlierDescription ? 'tooltip' : null,
        "data-placement": designation.friendlierDescription ? 'right' : null,
        "title": designation.friendlierDescription ? designation.friendlierDescription : null,
        "data-html": designation.friendlierDescription ? 'true' : null
      }
    }, [_vm._v(_vm._s(designation.description))]), designation.tooltip ? _c('i', {
      staticClass: "fas fa-info-circle text-dark",
      attrs: {
        "data-toggle": "tooltip",
        "data-placement": "right",
        "data-title": designation.tooltip,
        "data-html": "true"
      }
    }) : _vm._e()])]);
  }), 0)]), _c('div', {
    staticClass: "card-footer"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'programScoreCard',
        query: {
          scrollTop: true
        },
        params: {
          entityId: _vm.entityProgram.EntityId,
          programId: _vm.entityProgram.ProgramId
        }
      }
    }
  }, [_vm._v(" See how scores are calculated "), _c('i', {
    staticClass: "fas fa-chevron-circle-right ml-1"
  })])], 1)])])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.$store.state.programId != 0,
      expression: "$store.state.programId != 0"
    }]
  }, [_c('domain-comparison', {
    attrs: {
      "domain": _vm.routeDomain ? _vm.routeDomain : _vm.overall,
      "facts": _vm.routeDomain ? _vm.entityProgram.Facts.filter(x => _vm.routeDomain.Indicators.some(y => y.DomainIndicatorId === x.DomainIndicatorId)) : _vm.entityProgram.Facts
    }
  })], 1)])]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "card-header bg-transparent"
  }, [_c('h4', {
    staticClass: "mb-0"
  }, [_vm._v("Why is this important?")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "card-header bg-transparent"
  }, [_c('h4', {
    staticClass: "mb-0"
  }, [_vm._v("What do scores mean?")])]);
}];
export { render, staticRenderFns };